import React from 'react';
//  eslint-disable-next-line import/no-unresolved
import '@aws-amplify/ui-react/styles.css';
import { AboutUs, FindUs, IntroHeader, LexemeAIHeader, LexiLensAIHeader } from './container';
// import { AboutUs, FindUs, SwiftHeader, SwiftUIHeader, VisionOSHeader, AwsHeader, IntroHeader, WorkshopsHeader, ProductsHeader /* , Careers */ } from './container';
import { Navbar } from './components';
import './App.css';

const App = () => (
  <div>
    <div>
      <Navbar />
      <IntroHeader />
      <LexiLensAIHeader />
      <LexemeAIHeader />
      {/* <LexiLiteAIHeader /> */}
      {/* <ClassifyCamAIHeader /> */}
      {/* <EdTechPlatformHeader /> */}
      {/* <ProductsHeader /> */}
      {/* <AwsHeader /> */}
      {/* <GenAIHeader /> */}
      {/* <SwiftHeader /> */}
      {/* <SwiftUIHeader /> */}
      {/* <VisionOSHeader /> */}
      {/* <WorkshopsHeader /> */}
      <FindUs />
      <AboutUs />
      {/* <Careers /> */}
      {/* Social links relocated to About section */}
    </div>
  </div>
);

export default App;
//  export default withAuthenticator(App);
